import { ROUTES } from 'const';

const estimateToPdf = (estimateNumber) => {
    if (!estimateNumber) return;
    window.print();
};

const convertToSale = (history, identifier) => {
    if (!identifier) return;
    history.push(`${ROUTES.MANAGE_SALES}?estimate_id=${identifier}`);
};

const EstimateHelper = {
    estimateToPdf,
    convertToSale
};

export default EstimateHelper;
